import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { bodySmall } from '@/styles/typography';

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  max-width: 520px;
`;

export const InlineAction = styled.button<{ $danger?: boolean }>`
  ${bodySmall};
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  font-weight: 600;
  color: ${({ $danger }) => ($danger ? COLORS.red[600] : COLORS.green[600])};
`;

export const KeyValueRow = styled.div`
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr);
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid ${COLORS.grey[200]};
  ${bodySmall};

  &:last-child {
    border-bottom: 0;
  }
`;

export const OptionCard = styled.button<{ $active?: boolean; $locked?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid ${({ $active }) => ($active ? COLORS.green[500] : COLORS.grey[300])};
  box-shadow: ${({ $active }) => ($active ? `0 0 0 1px ${COLORS.green[600]}` : 'none')};
  background: ${({ $active, $locked }) => ($locked ? COLORS.grey[150] : $active ? COLORS.green[50] : COLORS.white)};
  cursor: ${({ $locked }) => ($locked ? 'default' : 'pointer')};
  text-align: left;
`;

export const OptionGrid = styled.div<{ $cols?: number; $gap?: string }>`
  display: grid;
  grid-template-columns: repeat(${({ $cols = 2 }) => $cols}, minmax(0, 1fr));
  gap: ${({ $gap = '12px' }) => $gap};
`;

export const VaultAccountsWrapper = styled.div`
  display: contents; /* keeps the cards' current layout untouched */
  overflow-anchor: none;
`;
